import { Select } from '@headlessui/react';
import React, { useCallback, useEffect, useState } from 'react'
import { BsBox } from 'react-icons/bs';
import * as XLSX from 'xlsx';
import { FaSyncAlt, FaUpload } from 'react-icons/fa';
import { FiDownload, FiFilter, FiX } from 'react-icons/fi';
import { GET_DASHBOARD_SUMMERY } from '../../graphql/Query/Signin.js';
import { useLazyQuery, useQuery } from '@apollo/client';
import DateFilter from '../../Common/DateRange.js';
import { toast } from 'react-toastify';
import Table from "../../components/Table/index.jsx"
import { orderTableColumns } from '../../components/Constant/index.js';
import { GET_ORDER_ADMIN_COUNT, GET_ORDER_COUNT, GET_ORDERS_CUSTOMER_FOR_ADMIN } from '../../graphql/Query/Order.js';
import { FaChevronDown } from 'react-icons/fa6';
import { handleTabClick } from '../../OrderPage/DashShipment.js';
import { typeOptions } from '../AdminTodayOrder.js';
import { getDateRange } from '../../Common/GetDateRange.js';
import moment from 'moment';
// import AdminCustomerHeader from './AdminCustomerHeader.js'

const AdminCustomerShipment = ({ location }) => {
    const [activeTab, setActiveTab] = useState("All");
    const [selectedMoreOption, setSelectedMoreOption] = useState("");
    const [isOpen, setIsOpen] = useState();
    const [awbNumber, setawbNumber] = useState();
    const [searchUser, setSearchUser] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [toggleCleared, settoggleCleared] = useState(false);
    const [multipleId, setMultipleId] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [sort, setSort] = useState({ key: "createdAt", type: -1 });
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedCheckBox, setSelectedCheckBox] = useState();
    const [fromDate, setFromDate] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [selectedDayRange, setSelectedDayRange] = useState("");
    // console.log('✌️orderData --->', orderData);


    const handleClear = () => {
        settoggleCleared(!toggleCleared);
        setSelectedCheckBox()
        setMultipleId([]);

    }


    // console.log('✌️location --++++++->', location);
    // We'll store the final date range in state, as provided by DateFilter
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index + 1,
                "Order ID": shipment?.order_id,
                "Order Number": shipment?.order_number,
                "Shipment Date": moment(shipment?.createdAt).format('DD/MM/YYYY'),
                "COD Collectable Amount.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "Payment": shipment?.ProductPrice,
                "Payment Mode": shipment?.payment_type,
                "AWB Number": shipment?.awb_number,
                "Customer Name": shipment?.deliveryAddress?.name,
                "Phone Number": shipment?.deliveryAddress?.phone,
                Address: fullAddress,
                City: city,
                State: state,
                "Zip Code": zipCode,
                "Tracking Status": shipment?.status,
                "Delivery Date": shipment?.delivery_order_Date,
                "Weight (Kg)": shipment?.package_weight,
                Product: shipment?.ProductName,


                // "COD Collection Rs.": `${shipment?.codCollectableValue}`,
                // "Shipment Charge": `₹${shipment?.order_amount}`,
                // // "phone":demoo,
                // "RTO Charges": `${shipment?.rto_order_charge || 0}`,
                // "Total Amount": `${shipment?.final_order_amount || 0}`,
            };
        });
    };

    // Destructure the final range to pass to the query
    const { filterType, startDate, endDate } = finalRange;

    // Convert startDate and endDate to ISO
    const isoStart = startDate?.toISOString();
    const isoEnd = endDate?.toISOString();
    const [showFilters, setShowFilters] = useState(true);
    const { data } = useQuery(GET_DASHBOARD_SUMMERY, {
        variables: {
            filter: {
                dateRange: {
                    startDate: isoStart,
                    endDate: isoEnd,
                },
                customerID: location?.customerId
            }
        },
        fetchPolicy: "cache-and-network"
    });
    // console.log('✌️data --->', data);
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);
    const onSelectedRowsChange = (data) => {
        if (data?.selectedCount > 0) {
            const Ids = data?.selectedRows?.map((d) => d)
            // console.log('✌️Ids --->', Ids);
            setMultipleId(Ids)
            setSelectedCheckBox(data?.selectedCount)
        } else {
            handleClear();
        }
    }
    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };
    const [fetchAllOrders] = useLazyQuery(GET_ORDERS_CUSTOMER_FOR_ADMIN, {
        fetchPolicy: "cache-and-network"
    });
    const { data: GetOrderOrder, loading } = useQuery(GET_ORDERS_CUSTOMER_FOR_ADMIN, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            from: finalRange?.startDate?.toISOString(),
            to: finalRange?.endDate?.toISOString(),
            "orderStatus": orderStatus,
            "codPaymentStatus": cod_payment_status,
            dayRange: selectedDayRange,
            // deliveryDate: selectedDayRangeDelivered,
            paymentStatus: selectedPaymentType,
            customerId: location?.customerId

        },
        fetchPolicy: "cache-and-network"
    });
    const { data: countData, refetch: refetchCount } = useQuery(GET_ORDER_ADMIN_COUNT, {
        variables: {
            // tag: 'All Courier',
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(),
            to: finalRange?.endDate?.toISOString(),
            paymentType: selectedPaymentType,
            customerId: location?.customerId

        },
        fetchPolicy: "cache-and-network",
    })
    // console.log('✌️countData --->', countData);
    useEffect(() => {
        if (GetOrderOrder?.getCustomerOrdersAllForAdmin?.data) {
            setOrderData(GetOrderOrder?.getCustomerOrdersAllForAdmin?.data);
        }
    }, [GetOrderOrder]);
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);

        handleClear();
    }
    const handleTabClick = (tab) => {
        // console.log('✌️tab --->', tab);
        setActiveTab(tab);
        handleClear();
        if (tab === 'All') {
            setorderStatus('');
        } else if (tab === 'Cancelled') {
            setorderStatus('cancelled');
        } else if (tab === 'Pending Pickup') {
            setorderStatus('pending pickup');
        } else if (tab === 'In Transit') {
            setorderStatus('in transit');
        } else if (tab === 'Out For Delivery') {
            setorderStatus('out for delivery');
        } else if (tab === 'Delivered') {
            setorderStatus('delivered');
        } else if (tab === 'RTO') {
            setorderStatus('rto');
        } else if (tab === 'RTO Delivered') {
            setorderStatus('rto delivered');
        } else if (tab === 'Booked') {
            setorderStatus('booked');
        } else {
            setorderStatus('');
        }
        refetchCount()
        setSelectedMoreOption("");
    };
    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: 1,
                limit: 100000,
                "sort": sort,
                tag: 'All Courier',
                "filter": filter.trim(),
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),
                orderStatus: orderStatus,
                paymentStatus: selectedPaymentType,
            },
            fetchPolicy: "cache-and-network"
        });

        if (!data?.getCustomerOrdersAllForAdmin?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getCustomerOrdersAllForAdmin?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "shipments.xlsx");
    };

    const options = [
        "RTO",
        "RTO Delivered",
        "RTO Lost",
        "RTO Damaged",
        "RTO In Transit",
        "Lost",
        "Damaged",
    ];

    const handleDropdownSelect = (option) => {
        setSelectedMoreOption(option);
        setActiveTab(option); // Highlight active tab from dropdown
        setIsOpen(false);
        setorderStatus(option?.toLocaleLowerCase())
    };
    const resetData = () => {
        setPage(1);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedPaymentType('');
        setActiveTab('All');
        handleClear();
        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

    }
    return (
        <>
            <div className='grid lg:grid-cols-3 md:grid-cols-3 gap-8 grid-cols-1'>
                <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-3">
                    <h3 className="text-lg font-semibold text-gray-800">Total Shipments</h3>
                    <p className="text-3xl font-bold text-blue-600">{data?.getDashboardData?.totalShipments}</p>
                    <p className="text-sm text-gray-500">Total forward shipments</p>
                </div>
                <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-3">
                    <h3 className="text-lg font-semibold text-gray-800">Delivered Orders</h3>
                    <p className="text-3xl font-bold text-blue-600">{data?.getDashboardData?.deliveredOrders} - {data?.getDashboardData?.deliveredPercentage}%</p>
                    <p className="text-sm text-gray-500">Total forward delivered orders</p>
                </div>
                <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-3">
                    <h3 className="text-lg font-semibold text-gray-800">COD Revenue  -  Prepaid Revenue = Total Revenue</h3>
                    <p className="text-3xl font-bold text-blue-600">₹{data?.getDashboardData?.codRevenue} - ₹{data?.getDashboardData?.prepaidRevenue} = ₹{data?.getDashboardData?.revenue}</p>
                    <p className="text-sm text-gray-500">Delivered Order Value</p>
                </div>

                {(data?.getDashboardData?.statusWise?.length > 0) && (
                    <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-5">
                        <h3 className="text-lg font-semibold text-gray-800">Shipment Insights</h3>
                        {/* Status Wise */}
                        {data?.getDashboardData?.statusWise?.length > 0 && (
                            <div className="space-y-1">
                                <h4 className="text-md font-semibold text-gray-700">Status Breakdown</h4>
                                {data.getDashboardData.statusWise.map((item, index) => (
                                    <p key={`status-${index}`} className="text-gray-600 capitalize">
                                        {item.status}: <span className="font-bold text-blue-600">{item.count}</span>
                                    </p>
                                ))}
                            </div>
                        )}
                        <p className="text-sm text-gray-500">Status summary</p>
                    </div>
                )}


                {/* State Wise */}
                {(data?.getDashboardData?.stateWise?.length > 0) && (
                    <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-5">
                        <h3 className="text-lg font-semibold text-gray-800">Shipment Insights</h3>

                        {data?.getDashboardData?.stateWise?.length > 0 && (
                            <div className="space-y-1">
                                <h4 className="text-md font-semibold text-gray-700">State Breakdown</h4>
                                {data.getDashboardData.stateWise.map((item, index) => (
                                    <p key={`state-${index}`} className="text-gray-600">
                                        {item.state}: <span className="font-bold text-blue-600">{item.count}</span>
                                    </p>
                                ))}
                            </div>
                        )}
                        <p className="text-sm text-gray-500">Status summary</p>
                    </div>
                )}



                {data?.getDashboardData?.paymentWise?.length > 0 && (
                    <div className="bg-blue-50 shadow-sm rounded-2xl p-6 flex flex-col items-center text-center space-y-3">
                        <h3 className="text-lg font-semibold text-gray-800">Payment Breakdown</h3>
                        <div className="space-y-1">
                            {data.getDashboardData.paymentWise.map((item, index) => (
                                <p key={index} className="text-lg font-medium text-blue-600 capitalize">
                                    {item.paymentType}: <span className="font-bold">{item.count}</span>
                                </p>
                            ))}
                        </div>
                        <p className="text-sm text-gray-500">Total by Payment Type</p>
                    </div>
                )}



            </div>


            <div className="flex overflow-hidden">
                {/* Sidebar */}
                {/* <SideBar /> */}

                {/* Main Content */}
                <div className="flex-1 space-y-3 px-0 py-6">
                    <div className="">
                        <div className="p-6 bg-gradient-to-r from-blue-50 via-blue-50 to-blue-50 border rounded-lg space-y-6">
                            {/* Header Section */}
                            <div className="flex flex-col md:flex-row items-center justify-between gap-3 w-full">
                                <h1 className="text-xl font-bold text-left w-full md:w-auto">Shipments</h1>

                            </div>

                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 w-full">
                                {/* Title & Icon Section */}
                                <div className='md:block hidden'>
                                    <div className="flex items-center gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div></div>
                                <div className='block md:hidden'>
                                    <div className="flex gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl hidden md:block text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 md:text-left">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div>
                                </div>

                                {/* Button Section */}
                                <div className="flex flex-col sm:flex-row flex-wrap justify-Start lg:justify-end gap-3 w-full">
                                    <button
                                        onClick={() => window.location.reload()}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        <FaSyncAlt /> Refresh
                                    </button>
                                    <button
                                        onClick={downloadExcel}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        <FiDownload className="text-lg" />
                                        Export
                                    </button>
                                    <button
                                        onClick={() => setShowFilters(!showFilters)}
                                        className="flex items-center justify-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                    >
                                        {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                        {showFilters ? "Close" : "Filter"}
                                    </button>
                                </div>
                            </div>

                            {/* Filter Section */}
                            {showFilters && (
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                    {/* Search Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Custom Search</label>
                                        <input
                                            type="text"
                                            value={searchUser}
                                            onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                                            // onKeyDown={handleSearch}
                                            placeholder="Search..."
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>


                                    {/* Order IDs */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Customer
                                        </label>
                                        <input
                                            type="text"
                                            value={filterOrder}
                                            onChange={(e) => { setFilterOrder(e.target.value); handleSearch(e, 'orderId') }}                                     // onKeyDown={() => handleSearch('orderId')}
                                            placeholder="Customer Name"
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* AWB Numbers */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            AWB No.
                                        </label>
                                        <input
                                            type="text"
                                            value={awbNumber}
                                            onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                            placeholder="AWB Nos (comma-separated)"
                                            className="w-full border border-gray-300 rounded-md   px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* Type Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                                        <Select
                                            options={typeOptions}
                                            defaultValue={typeOptions[0]}
                                            className="w-full"
                                            onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                            classNamePrefix="react-select"
                                            isSearchable={false}
                                            value={typeOptions.find(option => option?.value === selectedPaymentType) || null}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                    '&:hover': { borderColor: '#64748B' },
                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                    borderRadius: '0.375rem',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                    color: state.isSelected ? '#000000' : '#000000',
                                                    fontSize: '0.875rem',
                                                    '&:hover': {
                                                        backgroundColor: '#cbd5e1',
                                                        color: '#000000',
                                                        fontSize: '0.875rem',
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '14px',
                                                    color: '#A3AAB5',
                                                    fontSize: '0.875rem',
                                                }),
                                            }}
                                        />
                                    </div>


                                    {/* Date Filters */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                        <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />

                                    </div>

                                    <div className="flex items-end h-full" >

                                        <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400" onClick={resetData}>
                                            Reset Filters
                                        </p>
                                    </div>
                                </div>
                            )}
                            {/* Tab Section */}
                            <div className="border-t">
                                <div className="flex flex-wrap gap-4 mt-6">
                                    {[
                                        { name: "All" },
                                        { name: "Booked", count: countData?.getOrderStatusAdminCounts?.statusCounts?.booked || 0 },
                                        { name: "Pending Pickup", count: countData?.getOrderStatusAdminCounts?.statusCounts?.pendingpickup || 0 },
                                        { name: "In Transit", count: countData?.getOrderStatusAdminCounts?.statusCounts?.intransit || 0 },
                                        { name: "Out For Delivery", count: countData?.getOrderStatusAdminCounts?.statusCounts?.outfordelivery || 0 },
                                        { name: "Delivered", count: countData?.getOrderStatusAdminCounts?.statusCounts?.delivered || 0 },
                                        { name: "Cancelled", count: countData?.getOrderStatusAdminCounts?.statusCounts?.cancelled || 0 },
                                    ].map(({ name, count }) => (
                                        <button key={name} onClick={() => handleTabClick(name)}
                                            className={`px-4 py-1 text-sm shadow-md font-medium rounded-md ${activeTab === name ? "bg-slate-900 text-white" : "bg-white text-gray-700 border border-gray-300 hover:bg-slate-100"
                                                }`}>
                                            {name} {name === 'All' ? "" : `(${count})`}
                                        </button>
                                    ))}
                                    <div className="relative inline-block text-left">
                                        <div className="relative inline-block text-left">
                                            <button
                                                onClick={() => setIsOpen(!isOpen)}
                                                className={`flex items-center justify-between px-4 py-1 shadow-md text-sm font-medium rounded-lg transition border ${selectedMoreOption ? "bg-slate-900 text-white border-slate-900" : "bg-white text-gray-700 border-gray-300 hover:bg-slate-100"
                                                    }`}
                                            >
                                                {selectedMoreOption || "More"} <FaChevronDown className="ml-2 text-xs" />
                                            </button>

                                            {isOpen && (
                                                <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-40">
                                                    <ul className="py-2">
                                                        {options.map((option, index) => (
                                                            <li
                                                                key={index}
                                                                className="px-4 py-2 text-gray-700 hover:bg-slate-100 cursor-pointer"
                                                                onClick={() => handleDropdownSelect(option)}
                                                            >
                                                                {option}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <Table
                            columns={orderTableColumns}
                            data={orderData || []}
                            currentPage={page}
                            totalRecords={GetOrderOrder?.getCustomerOrdersAllForAdmin?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            handlePagination={handlePagination}
                            multiSelectRow={onSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default AdminCustomerShipment
